import type { ScreenshareTransition } from '../../features/screenshare/screenshare.types';

export enum ScreenshareRequestPayload {
  Request = 'request',
  Accept = 'accept',
  Reject = 'reject',
  Cancel = 'cancel',
  Stop = 'stop',
  Stopped = 'stopped',
}

export type TransitionFunc = (
  type: ScreenshareTransition,
  eventData?: ScreenshareEventData,
) => Promise<void>;

export type ScreenshareEventData = {
  realtimeMemberId?: string;
  errorType?: ScreenshareErrorType;
};

export type ScreenshareErrorType = 'PERMISSIONS_ERROR' | 'INIT_FAILED';
